import { render, staticRenderFns } from "./LsCover.vue?vue&type=template&id=d5fbc43c&scoped=true&"
import script from "./LsCover.vue?vue&type=script&lang=js&"
export * from "./LsCover.vue?vue&type=script&lang=js&"
import style0 from "./LsCover.vue?vue&type=style&index=0&id=d5fbc43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fbc43c",
  null
  
)

export default component.exports